module.exports = __webpack_public_path__ + "assets/img/tthumb_emplate_img.8724a337.svg";